/**
 * 工单质量审核接口
 */

const prefix = '/dseWeb'
export default [
  // 查询工单质量审核列表（分页）
  { name: 'getWorkOrderAuditPage', url: `${prefix}/v1/op/errorAppr/page`, method: 'post' },
  
  // 提交审核
  { name: 'submitWorkOrderAudit', url: `${prefix}/v1/op/errorAppr/appr`, method: 'post' },
  
  // 获取工单详情
  { name: 'getWorkOrderDetail', url: `${prefix}/v1/op/errorAppr/info`, method: 'get' }
]
